import Vue from 'vue';

Vue.component('navBar', require('../../components/Header.vue').default);
Vue.component('bottomBar', require('../../components/Footer.vue').default);
Vue.component('alert', require('../../components/Alert.vue').default);

Vue.component('inactiveCity', require('../../components/InactiveCity.vue').default);
Vue.component('inspectLead', require('../../components/LeadInspect.vue').default);
